import { render, staticRenderFns } from "./CIGWarehouseCapacity.vue?vue&type=template&id=51b053dc&scoped=true&"
import script from "./CIGWarehouseCapacity.vue?vue&type=script&lang=js&"
export * from "./CIGWarehouseCapacity.vue?vue&type=script&lang=js&"
import style0 from "./CIGWarehouseCapacity.vue?vue&type=style&index=0&id=51b053dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b053dc",
  null
  
)

export default component.exports